import React, { useState } from "react";
import  { useRef } from "react";
import "../style/Career.css";
import LeaveMessage from "./LeaveMessage";
import emailjs from "emailjs-com";


const Career = () => {
  const [showForm, setShowForm] = useState(false);
  //  const { category, type, model, id } = useParams();
  const form = useRef();

  // EmailJS handler
  const sendEmail = (e) => {
  e.preventDefault();


   emailjs.sendForm(
  "service_made04j",      // ✅ Full Service ID
  "template_jh8k3hg",     // ✅ Full Template ID
  form.current,            // form reference
  "-86tPl3RmB96yNv4j" // ✅ Full Public Key
)
    .then(
      (result) => {
        console.log("✅ Email sent successfully:", result.text); // ✅ Console me bhi success
        alert("✅ Message sent successfully!");
        form.current.reset();
      },
      (error) => {
        console.error("❌ EmailJS error:", error.text); // ❌ Console me error details
        alert("❌ Failed to send message. Check console for details.");
      }
    );
};



  return (
    <>
      {/* ---------------- SEARCH RESULTS (Optional) ---------------- */}
      <div id="searchResults"></div>

      <LeaveMessage />

      {/* ---------------- CAREER HEADING ---------------- */}
      <section>
        <div className="heading-section">
          <h2>CAREER</h2>
        </div>
      </section>

      {/* ---------------- CAREER IMAGES GRID ---------------- */}
      <section>
        <div className="section-grid-img">
          <img src="/career/career .jpg" alt="Career 1" />
          {/* <img src="/career/2.jpg" alt="Career 2" />
          <img src="/career/3.jpg" alt="Career 3" />
          <img src="/career/4.jpg" alt="Career 4" />
          <img src="/career/5.jpg" alt="Career 5" />
          <img src="/career/6.jpg" alt="Career 6" /> */}
        </div>
      </section>

      {/* ---------------- CAREER SECTION 1 ---------------- */}
      <section>
        <div className="section-1">
          <h6>
            <strong>
              We’re always looking for passionate and talented people to join our growing team.
              At A-OK Motors, we believe in innovation, teamwork, and creating impactful solutions.

            </strong>
          </h6>
          <p>
            Work Location <br />

            📍 Our office is based in Ahmedabad, Gujarat. <br />
            👉 All roles are on-site only, which means you will be working from our Ahmedabad office.

          </p>
          <p>
            Why Join Us? <br />
            Work in a collaborative and supportive environment Opportunities to grow and learn be part of a fast-growing company with exciting projects


          </p>
          <p>
            If you’re willing to join us and want to build your career with us, please leave us a message, we will reply you as soon as we can!
          </p>
        </div>
      </section>

      <section>
              <div className="contact-form-container" style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <h2 className="section-title">Leave a Message</h2>
                <form ref={form} onSubmit={sendEmail} className="contact-form" encType="multipart/form-data">
                  {/* Hidden subject with product name */}
                  <input type="hidden" name="subject" />
                  
                  <input type="email" name="email" placeholder="Your Email *" required />
                 
                  <input type="text" name="phone" placeholder="Tel/Whatsapp" />

                  {/* Message */}
                  {/* <textarea name="message" placeholder="Enter product details..." required /> */}

                  {/* 👇 Add this file input */}
                  <label style={{ display: "block", marginBottom: "8px" }}>
                    Upload Document (Resume / CV):
                  </label>
                  <input
                    type="file"
                    name="my_file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    required
                    style={{ marginBottom: "15px" }}
                  />

                  <button type="submit" className="btn-inquiry">Submit</button>
                </form>
              </div>
      </section>

    </>
  );
};

export default Career;
